import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import SearchResultListPage from "containers/SearchResultListPage/SearchResultListPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
import AuthorPage from "containers/AuthorPage/AuthorPage";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import AdminPageApplications from "containers/AdminPageApplications";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSignUpPending from "containers/PageSignUpPending";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import PageCompanyRegister from "containers/PageCompanyRegister/PageCompanyRegister";
import PageCompanyRegister2 from "containers/PageCompanyRegister/PageCompanyRegister2";
import PageCreateBrand from 'containers/PageCreateBrand';
import PageBrandDetail from 'containers/PageBrandDetail';
import PageAgencyDetail from 'containers/PageAgencyDetail';
import PageFavorites from 'containers/PageFavorites';
import PageBrandImages from 'containers/PageCreateBrand/PageAttachImages';
import PageAddListing1 from "containers/PageAddListing1/PageAddListing1";
import PageAddListing2 from "containers/PageAddListing1/PageAddListing2";
import PageAddListing3 from "containers/PageAddListing1/PageAddListing3";
import PageAddListing4 from "containers/PageAddListing1/PageAddListing4";
import PageAddListing5 from "containers/PageAddListing1/PageAddListing5";
import PageAddListing6 from "containers/PageAddListing1/PageAddListing6";
import PageAddListing7 from "containers/PageAddListing1/PageAddListing7";
import PageAddListing8 from "containers/PageAddListing1/PageAddListing8";
import PageAddListing9 from "containers/PageAddListing1/PageAddListing9";
import PageAddListing10 from "containers/PageAddListing1/PageAddListing10";
import PageAccount from "containers/PageAccount";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";
import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
import PageApplicationPending from "containers/PageApplicationPending/PageApplicationPending";
import { connect, useSelector, useDispatch } from "react-redux";
import ForgotPass from "containers/ForgotPasswordPage/ForgotPass";
import ResetPassword from "containers/ForgotPasswordPage/ResetPassword";
import PageBlacklists from "containers/PageBlacklists";
import PageAgentMatch from "containers/AgentMatch/PageAgentMatch";
import SimpleAgencyProfile from "containers/PageAgencyDetail/SimpleAgencyProfile";
import { updateLoadingIsStatus } from "../redux/reducers/spinnerReducer.js";

interface RootState {
    spinner: {
      isLoading: boolean;
    };
    user: {
      user: any;
    };
  }

const pageTitles = {
  "/": "Home",
  "/search": "Search",
  "/listing-stay-map": "Stay Map",
  "/listing-stay-detail": "Stay Details",
  "/author": "Author Profile",
  "/account": "Account",
  "/favorites": "Favorites",
  "/blacklist": "Blacklists",
  "/account-password": "Password Settings",
  "/account-savelists": "Saved Lists",
  "/add-listing-1": "Add Listing - Step 1",
  "/add-listing-2": "Add Listing - Step 2",
  "/add-listing-3": "Add Listing - Step 3",
  "/add-listing-4": "Add Listing - Step 4",
  "/add-listing-5": "Add Listing - Step 5",
  "/add-listing-6": "Add Listing - Step 6",
  "/add-listing-7": "Add Listing - Step 7",
  "/add-listing-8": "Add Listing - Step 8",
  "/add-listing-9": "Add Listing - Step 9",
  "/add-listing-10": "Add Listing - Step 10",
  "/contact": "Contact Us",
  "/about": "About Us",
  "/register": "Register",
  "/register/brand": "Brand Registration",
  "/register/agency": "Agency Registration",
  "/register/brand/2": "Brand Registration - Step 2",
  "/register/agency/2": "Agency Registration - Step 2",
  "/subscription": "Subscription",
  "/pending-applications": "Pending Applications",
  "/create-brand": "Create Brand",
  "/brand/images": "Brand Images",
  "/forgot-pass": "Forgot Password",
  "/reset-password": "Reset Password",
  "/register/thank-you": "Registration Complete",
  "/login": "Login",
  "/applications": "Manage Applications",
  "/agent-match" : 'Agent Match',
};

export const auth_pages: Page[] = [
    { path: "/", exact: true, component: PageHome },
    { path: "/#", exact: true, component: PageHome },
    //
    { path: "/search", component: SearchResultListPage },
    { path: "/listing-stay-map", component: ListingStayMapPage },
    { path: "/listing-stay-detail", component: ListingStayDetailPage },
    //
    { path: "/author", component: AuthorPage },
    { path: "/account", component: PageAccount },
    { path: "/favorites", component: PageFavorites },
    { path: "/blacklist", component: PageBlacklists },
    { path: "/account-password", component: AccountPass },
    { path: "/account-savelists", component: AccountSavelists },
    //
    { path: "/add-listing-1", component: PageAddListing1 },
    { path: "/add-listing-2", component: PageAddListing2 },
    { path: "/add-listing-3", component: PageAddListing3 },
    { path: "/add-listing-4", component: PageAddListing4 },
    { path: "/add-listing-5", component: PageAddListing5 },
    { path: "/add-listing-6", component: PageAddListing6 },
    { path: "/add-listing-7", component: PageAddListing7 },
    { path: "/add-listing-8", component: PageAddListing8 },
    { path: "/add-listing-9", component: PageAddListing9 },
    { path: "/add-listing-10", component: PageAddListing10 },
    //
    { path: "/contact", component: PageContact },
    { path: "/about", component: PageAbout },
    { path: "/register", component: PageSignUp },
    { path: "/register/brand", component: PageCompanyRegister },
    { path: "/register/agency", component: PageCompanyRegister },
    { path: "/register/brand/2", component: PageCompanyRegister2 },
    { path: "/register/agency/2", component: PageCompanyRegister2 },
    { path: "/subscription", component: PageSubcription },
    { path: "/agent-match", component: PageAgentMatch },

    //
    { path: "/pending-applications", component: PageSubcription },
    { path: "/create-brand", component: PageCreateBrand },
    { path: "/brand/images", component: PageBrandImages },
    { path: "/brand/:shortname", component: PageBrandDetail },
    { path: "/agency/:shortname", component: SimpleAgencyProfile },
    { path: "/register/thank-you", exact: true, component: PageSignUpPending },

    { path: "/view/brand/:shortname", component: PageBrandDetail },
    { path: "/view/agency/:shortname", component: SimpleAgencyProfile },
];

export const public_pages: Page[] = [
    { path: "/forgot-pass", component: ForgotPass },
    { path: "/reset-password", component: ResetPassword},
    { path: "/register", component: PageSignUp },
    { path: "/register/brand", component: PageCompanyRegister },
    { path: "/register/agency", component: PageCompanyRegister },
    { path: "/register/brand/2", component: PageCompanyRegister2 },
    { path: "/register/agency/2", component: PageCompanyRegister2 },
    { path: "/register/thank-you", exact: true, component: PageSignUpPending },
    { path: "/login", exact: true, component: PageLogin },
    { path: "/applications", exact: true, component: AdminPageApplications },
    { path: "/view/brand/:shortname", component: PageBrandDetail },
    { path: "/view/agency/:shortname", component: SimpleAgencyProfile },
    { path: "/", component: PageLogin },
];

const TitleUpdater = () => {
  const location = useLocation();
  
  const getPageTitle = () => {
    if (pageTitles[location.pathname]) {
      return `Agent Match | ${pageTitles[location.pathname]}`;
    }
    
    if (location.pathname.startsWith('/brand/') && location.pathname !== '/brand/images') {
      return 'Agent Match | Brand Details';
    }
    
    if (location.pathname.startsWith('/agency/')) {
      return 'Agent Match | Agency Details';
    }
    
    return 'Agent Match';
  };
  
  return (
    <Helmet>
      <title>{getPageTitle()}</title>
    </Helmet>
  );
};

const RoutesContent = ({user, isLoading, dispatch}) => {
  const location = useLocation();
  const [prevLoadingState, setPrevLoadingState] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(updateLoadingIsStatus(false));
    }, 100);
    
    return () => clearTimeout(timer);
  }, [location.pathname, dispatch]);
  const isSearchRelatedPage = location.pathname === '/search' || 
                              location.pathname.includes('/search') ||
                              location.pathname === '/listing-stay-map';
  
  const shouldShowGlobalLoading = isLoading && 
                                  !isSearchRelatedPage && 
                                  isLoading !== prevLoadingState;

  useEffect(() => {
    setPrevLoadingState(isLoading);
  }, [isLoading]);

  const token = localStorage.getItem('access_token');
  
  return (
    <>
      {shouldShowGlobalLoading && (
        <div 
          style={{
            position: 'fixed',
            top: '80px',
            left: 0,
            right: 0,
            height: '1px',
            background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
            zIndex: 1000,
            animation: 'slideLoadingLine 2s ease-in-out infinite'
          }}
        />
      )}
      
      {!token || !user?.id ? (
        <Routes>
          {public_pages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
          <Route path="*" element={<Page404 />} />
        </Routes>
      ) : user?.id && (!user?.company || !user?.company?.id) ? (
        (() => {
          const storedCompanyType = localStorage.getItem('company_type') || 'brand';
          const companyType = user?.company?.company_type || storedCompanyType;
          const currentLocation = window.location.pathname;
          
          if (!currentLocation.startsWith('/register/')) {
            return <Navigate to={`/register/${companyType}`} replace />;
          }
          
          return (
            <Routes>
              {auth_pages.filter(page => 
                page.path.startsWith('/register/') || 
                page.path === '/register' ||
                page.path === '/register/thank-you'
              ).map(({ component, path }) => {
                const Component = component;
                return <Route key={path} element={<Component />} path={path} />;
              })}
              <Route path="*" element={<Navigate to={`/register/${companyType}`} replace />} />
            </Routes>
          );
        })()
      ) : user?.id && user?.company?.id && !user?.company?.is_confirmed ? (
        <Routes>
          <Route path="/" element={<PageApplicationPending />} />
          <Route path="/#" element={<PageApplicationPending />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <Routes>
          {auth_pages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
          <Route path="*" element={<Page404 />} />
        </Routes>
      )}
    </>
  );
};

const MyRoutes = ({user, initialLoadComplete}) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.spinner.isLoading);
  
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  if (!initialLoadComplete) {
    return <div></div>;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <TitleUpdater />
      <SiteHeader />
      
      <RoutesContent user={user} isLoading={isLoading} dispatch={dispatch} />
      
      {WIN_WIDTH < 768 && <FooterNav />}
      <Footer />
    </BrowserRouter>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { })(
  MyRoutes
);
